import { render, staticRenderFns } from "./BatchModifyMainImage.vue?vue&type=template&id=4bad8c66&scoped=true"
import script from "./BatchModifyMainImage.vue?vue&type=script&lang=js"
export * from "./BatchModifyMainImage.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyMainImage.vue?vue&type=style&index=0&id=4bad8c66&prod&scoped=true&lang=css"
import style1 from "./BatchModifyMainImage.vue?vue&type=style&index=1&id=4bad8c66&prod&lang=css"
import style2 from "./BatchModifyMainImage.vue?vue&type=style&index=2&id=4bad8c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad8c66",
  null
  
)

export default component.exports